import { lighten } from '@mui/material/styles';

export const tintOnWhite = (base: string, alphaOnWhite: number): string => {
  const clamped = Math.min(1, Math.max(0, alphaOnWhite));
  return lighten(base, 1 - clamped);
};
